export const en = {
    lang: ["en"],
    normal: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
        "{tab} q w e r t y u i o p [ ] \\",
        "a s d f g h j k l ; ' {enter}",
        "{shift} z x c v b n m , . / {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    shift: [
        "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
        "{tab} Q W E R T Y U I O P { } |",
        'A S D F G H J K L : " {enter}',
        "{shift} Z X C V B N M < > ? {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    alt: [
        "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
        "{tab} q w e r t y u i o p [ ] \\",
        "a s d f g h j k l ; ' {enter}",
        "{shift} z x c v b n m , . / {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    "alt-shift": [
        "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
        "{tab} Q W E R T Y U I O P { } |",
        'A S D F G H J K L : " {enter}',
        "{shift} Z X C V B N M < > ? {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ]
};

export const nl = {
    lang: ["nl"],
    normal: [
        "@ 1 2 3 4 5 6 7 8 9 0 / Â° {bksp}",
        "{tab} q w e r t y u i o p Â¨ *",
        "a s d f g h j k l + ' {enter}",
        "{shift} z x c v b n m , . - {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    shift: [
        "\u00a7 ! \" # $ % & _ ( ) ' ? ~ {bksp}",
        "{tab} Q W E R T Y U I O P ^ |",
        "A S D F G H J K L \u00b1 ` {enter}",
        "{shift} Z X C V B N M ; : = {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    alt: [
        "@ 1 2 3 4 5 6 7 8 9 0 / Â° {bksp}",
        "{tab} q w e r t y u i o p Â¨ *",
        "a s d f g h j k l + ' {enter}",
        "{shift} z x c v b n m , . - {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    "alt-shift": [
        "\u00a7 ! \" # $ % & _ ( ) ' ? ~ {bksp}",
        "{tab} Q W E R T Y U I O P ^ |",
        "A S D F G H J K L \u00b1 ` {enter}",
        "{shift} Z X C V B N M ; : = {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ]
};

export const be = {
    lang: ["fr"],
    normal: [
        "1 2 3 4 5 6 7 8 9 0 Â° + {bksp}",
        "{tab} a z e r t y u i o p ^ $",
        "q s d f g h j k l m \u00f9 {enter}",
        "{shift} w x c v b n , ; : ! {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    shift: [
        "\u00b2 & 0 \" ' ( - \u00e8 _ \u00e7 \u00e0 ) = {bksp}",
        "{tab} A Z E R T Y U I O P \u0308 \u00a3",
        "Q S D F G H J K L M % {enter}",
        "{shift} W X C V B N ? . / \u00a7 {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    alt: [
        "\u00b2 & 0 \" ' ( - \u00e8 _ \u00e7 \u00e0 ) = {bksp}",
        "{tab} a z e r t y u i o p ^ $",
        "q s d f g h j k l m \u00f9 {enter}",
        "{shift} w x c v b n , ; : ! {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ],
    "alt-shift": [
        "1 2 3 4 5 6 7 8 9 0 Â° + {bksp}",
        "{tab} A Z E R T Y U I O P \u0308 \u00a3",
        "Q S D F G H J K L M % {enter}",
        "{shift} W X C V B N ? . / \u00a7 {shift}",
        "{accept} {alt} {space} {alt} {cancel}"
    ]
};
